<template>
    <div class="error-container">
        <div v-if="errors" class="errors" v-for="(errs, attribute) in errors" v-cloak>
            <div v-for="(err, index) in errs" class="error active">
                {{ err }}
                <span class="close" @click="removeError(attribute, index)"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ErrorList",
        props: ['list'],
        data () {
            return {
                errors: this.list
            };
        },
        methods: {
            removeError: function (attr, i) {
                this.errors[attr].splice(i, 1);
            }
        }
    }
</script>

<style scoped>

</style>